import { render, staticRenderFns } from "./yek-poissaolo-form.vue?vue&type=template&id=efa0e308&scoped=true&"
import script from "./yek-poissaolo-form.vue?vue&type=script&lang=ts&"
export * from "./yek-poissaolo-form.vue?vue&type=script&lang=ts&"
import style0 from "./yek-poissaolo-form.vue?vue&type=style&index=0&id=efa0e308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa0e308",
  null
  
)

export default component.exports